/**
 * DCALGeneratorPage - DCAL Generator with Modern Layout
 *
 * Same layout as Heat Profile: title, description, Back To Technical, tabs
 * (Heat Profile, Test Repository, DCAL Generator), then DCAL list card and table.
 * Uses ModernLayout. All DCAL functionality preserved (CRUD, PDF/Excel, modals).
 */

import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ChevronLeft, Flame, FileText, Wrench } from 'lucide-react';
import DcalPage from '../../components/DCAL/DcalPage';
import './HeatProfilePage.css';
import './DCALGeneratorPage.css';

const TECHNICAL_TAB_ITEMS = [
    { id: 'heat-profile', label: 'Heat Profile', path: '/heat-profile', icon: <Flame size={18} /> },
    { id: 'test-repository', label: 'Test Repository', path: '/TechnicalPage', icon: <FileText size={18} /> },
    { id: 'dcal-generator', label: 'DCAL Generator', path: '/DCALGenerator', icon: <Wrench size={18} /> },
];

const DCALGeneratorPage = () => {
    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    const handleBackClick = () => {
        if (window.history.length > 1) {
            history.goBack();
        } else {
            history.push('/technical');
        }
    };

    const handleTabClick = (path) => {
        if (path !== currentPath) {
            history.push(path);
        }
    };

    return (
        <div className="dcal-generator-page">
            <div className="dcal-generator-page-top-section">
                <div className="dcal-generator-page-heading">
                    <h1 className="dcal-generator-page-title">DCAL Generator</h1>
                    <p className="dcal-generator-page-description">
                        Generate and manage DCAL project reports and master data.
                    </p>
                    <a
                        href="#back"
                        onClick={(e) => {
                            e.preventDefault();
                            handleBackClick();
                        }}
                        className="dcal-generator-page-back-link"
                    >
                        <div className="dcal-generator-back-link">
                            <ChevronLeft size={16} /> Back To Technical
                        </div>
                    </a>
                </div>
            </div>

            <div className="dcal-generator-tabs-container">
                <div className="dcal-generator-tabs">
                    {TECHNICAL_TAB_ITEMS.map((item) => (
                        <div
                            key={item.id}
                            className={`dcal-generator-tab-item ${currentPath === item.path ? 'active' : ''}`}
                            onClick={() => handleTabClick(item.path)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleTabClick(item.path);
                                }
                            }}
                            role="tab"
                            tabIndex={0}
                            aria-selected={currentPath === item.path}
                        >
                            {item.icon}
                            {item.label}
                        </div>
                    ))}
                </div>
            </div>

            <div className="dcal-generator-divider" />

            <div className="dcal-generator-content-wrapper heat-profile-content-wrapper">
                <DcalPage embeddedInModernLayout />
            </div>
        </div>
    );
};

export default DCALGeneratorPage;
